import { render, staticRenderFns } from "./ConfigIntegrationAutomaticFileProcessing.vue?vue&type=template&id=3f28f626&scoped=true&"
import script from "./ConfigIntegrationAutomaticFileProcessing.vue?vue&type=script&lang=js&"
export * from "./ConfigIntegrationAutomaticFileProcessing.vue?vue&type=script&lang=js&"
import style0 from "./ConfigIntegrationAutomaticFileProcessing.vue?vue&type=style&index=0&id=3f28f626&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f28f626",
  null
  
)

export default component.exports